<p-toast></p-toast>
<div class="top-bar">
    <div class="top-items-container">
        <div>
            <a [href]="lviSiteUrl" target="_blank">
                <img class="logo" [src]="lviLogo">
            </a>
        </div>
    </div>
</div>
<div class="main-container">
    <div class="steps-container">
        <div *ngFor="let step of stepItems; let i = index"
            [ngClass]="{'selected-step-item-container': i == activeIndex, 'unselected-step-item-container': i != activeIndex}">
            <div>
                <div
                    [ngClass]="{'selected-step-item-circle': i == activeIndex, 'unselected-step-item-circle': i != activeIndex}">
                    <p>{{i+1}}</p>
                </div>
                <div
                    [ngClass]="{'selected-step-item-description-container': i == activeIndex, 'unselected-step-item-description-container': i != activeIndex}">
                    <p>{{step.label}}</p>
                </div>
            </div>
        </div>
    </div>
    <p-dialog [(visible)]="displaySchoolInformation" [modal]="true" header="School address">
        <div *ngIf="bookingInformation" class="booking-information-grid">
            <p class="bold">
                Address
            </p>
            <p>
                {{bookingInformation.schoolAddress}}
            </p>
            <p class="bold">
                Postal code
            </p>
            <p>
                {{bookingInformation.schoolPostCode}}
            </p>
            <p class="bold">
                City
            </p>
            <p>
                {{bookingInformation.schoolCity}}
            </p>
            <p class="bold">
                Country
            </p>
            <p>
                {{bookingInformation.schoolCountryName}}
            </p>
        </div>
    </p-dialog>
    <p-dialog [(visible)]="displayAccommodationInformation" [modal]="true" header="Accommodation information">
        <div *ngIf="bookingInformation" class="booking-information-grid">
            <p class="bold">
                Address
            </p>
            <p>
                {{bookingInformation.accommodationAddress}}
            </p>
            <p class="bold">
                Postal code
            </p>
            <p>
                {{bookingInformation.accommodationPostCode}}
            </p>
            <p class="bold">
                City
            </p>
            <p>
                {{bookingInformation.accommodationCity}}
            </p>
            <p class="bold">
                Country
            </p>
            <p>
                {{bookingInformation.accommodationCountryName}}
            </p>
        </div>
    </p-dialog>
    <p-dialog [(visible)]="displaySchoolEmergencyPhoneNumber" [modal]="true" header="emergency phone number of school">
        <p *ngIf="bookingInformation && bookingInformation.schoolEmergencyPhoneNumber">
            {{bookingInformation.schoolEmergencyPhoneNumber}}
        </p>
    </p-dialog>
    <div class="student-information-container">
        <div>
            <h3 i18n class="global-title">
                Student Data
            </h3>
            <div class="student-information-grid-left" *ngIf="bookingInformation">
                <p i18n>
                    Last name:
                </p>
                <p>
                    {{bookingInformation.studentLastName | titlecase}}
                </p>
                <p i18n>
                    First name:
                </p>
                <p>
                    {{bookingInformation.studentFirstName | titlecase}}
                </p>
                <p i18n>
                    Gender:
                </p>
                <p>
                    {{bookingInformation.studentGenderSymbol}}
                </p>
                <p i18n>
                    Nationality:
                </p>
                <p>
                    <!-- {{bookingInformation.studentNationality}} -->
                </p>
                <p i18n="Country of student">
                    Country:
                </p>
                <p>
                    {{bookingInformation.studentCountryName}}
                </p>
                <p i18n>
                    Birth date:
                </p>
                <p>
                    {{bookingInformation.studentBirthDate | date: 'dd/MM/yyyy'}}
                </p>
                <p i18n>
                    Email address:
                </p>
                <p>
                    {{bookingInformation.studentEmail}}
                </p>
                <p i18n>
                    Mobile number:
                </p>
                <p>
                    {{bookingInformation.studentMobileNumber}}
                </p>
            </div>
        </div>
        <div>
            <h3 class="global-title" i18n="Séjour">
                The stay
            </h3>
            <div class="student-information-grid-middle" *ngIf="bookingInformation">
                <p i18n>Destination:</p>
                <p>
                    {{bookingInformation.destination}}
                </p>
                <p i18n>School:</p>
                <p>{{bookingInformation.school}}</p>
                <p i18n="début de séjour">Start date:</p>
                <p>{{bookingInformation.startDate | date: 'dd/MM/yyyy'}}</p>
                <p i18n="fin de séjour">End date:</p>
                <p>{{bookingInformation.endDate | date: 'dd/MM/yyyy'}}</p>
                <p i18n="durée de séjour">Duration</p>
                <p i18n="durée de séjour">{{bookingInformation.duration}} week(s)</p>
                <p i18n>Language level:</p>
                <p>{{bookingInformation.studentLanguageLevel}}</p>
                <p i18n="cours sélectionné">Course:</p>
                <!-- <p>{{bookingInformation.translatedLanguageCourse}}</p> -->
                <p i18n="transfert logement - aéroport">Transfer</p>
                <p>{{bookingInformation.transferOption}}</p>
                <p i18n>Cancellation garantie:</p>
                <p i18n *ngIf="bookingInformation.needsCancellationGarantie">
                    Yes
                </p>
                <p i18n *ngIf="!bookingInformation.needsCancellationGarantie">
                    No
                </p>
                <p i18n>Travel insurance:</p>
                <p *ngIf="bookingInformation.needsTravelInsurance">
                    Yes
                </p>
                <p i18n *ngIf="!bookingInformation.needsTravelInsurance">
                    No
                </p>
            </div>
        </div>

        <div class="student-information-right-grid">
            <div class="information-buttons-container">
                <h3 i18n class="global-title">
                    Address of stay
                </h3>
                <p-button i18n-label label="School address" (onClick)="activateSchoolInformationDialog()"
                    [style]="{'width': '215px'}">
                </p-button>
                <p-button i18n-label label="Accommodation address" (onClick)="activateAccommodationInformationDialog()"
                    [style]="{'width': '215px'}"></p-button>
                <p-button i18n-label *ngIf="bookingInformation && bookingInformation.schoolEmergencyPhoneNumber"
                    label="Emergency Phone Number" (onClick)="activateSchoolEmergencyPhoneNumberDialog()"
                    [style]="{'width': '215px'}"></p-button>
                <p-button i18n-label label="Local organizer" [style]="{'width': '215px'}"></p-button>
            </div>
        </div>
    </div>
    <div>
        <p i18n>
            Uploaded files:
        </p>
        <div>
            <h3 i18n class="global-title">
                Documents of stay
            </h3>
            <p-table [value]="openBookingFiles">
                <ng-template pTemplate="header">
                    <tr>
                        <th i18n>
                            File name
                        </th>
                        <th i18n="Date of file creation">
                            Date
                        </th>
                        <th i18n>
                            Download
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-file>
                    <tr>
                        <td>
                            {{file.fileType}}
                        </td>
                        <td>
                            {{file.created | date: 'dd/MM/yyyy'}}
                        </td>
                        <td>
                            <p-button icon="pi pi-download" (onClick)="downloadBookingFile(file)"></p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="file-table-container">
            <h3 i18n class="global-title">
                Documents to complete
            </h3>
            <p-table [value]="openBookingFilesToComplete">
                <ng-template pTemplate="header">
                    <tr>
                        <th i18n>
                            File name
                        </th>
                        <th i18n="Date of file creation">
                            Date
                        </th>
                        <th i18n>
                            Completed
                        </th>
                        <th i18n>
                            Download
                        </th>
                        <th i18n>
                            Upload
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-file>
                    <tr>
                        <td>
                            {{file.fileType}}
                        </td>
                        <td>
                            {{file.created | date: 'dd/MM/yyyy'}}
                        </td>
                        <td>
                            <p *ngIf="file.isCompleted" i18n="file is completed/signed">
                                Yes
                            </p>
                        </td>
                        <td>
                            <p-button *ngIf="file.hasData" icon="pi pi-download" (onClick)="downloadBookingFile(file)">
                            </p-button>
                        </td>
                        <td>
                            <div *ngIf="!file.isCompleted">
                                <p-fileUpload #fileForm mode="basic" name="file" [customUpload]="true"
                                    (uploadHandler)="uploadCompletedFile($event, fileForm, file)">
                                </p-fileUpload>
                            </div>
                            <div i18n *ngIf="file.isCompleted">
                                Done !
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <!-- <div class="chat-message-container">
            <h3 i18n class="global-title">
                Discussion
            </h3>
            <ck-editor [(ngModel)]="chatMessage" [config]="editorConfig" skin="moono-lisa" language="en"
                [fullPage]="false"></ck-editor>
            <p-captcha #captcha siteKey="6LcS4YkfAAAAAMMUGj-e1OKPzv_d6EYAicTtjyKF"
                (onResponse)="updateRecaptchaResponse($event)"></p-captcha>
            <p-button label="Submit" (onClick)="postChatMessage()"
                [disabled]="!recaptchaResponse || !chatMessage || chatMessage.length > maxTextLength"></p-button>
            <div *ngFor="let chat of bookingChats"
                [ngClass]="{'chat-message-right': chat.createdBy, 'chat-message-left': !chat.createdBy}">
                <div [innerHTML]="chat.message | safeHtml"
                    [ngClass]="{'chat-text-container-right': chat.createdBy, 'chat-text-container-left': !chat.createdBy}">
                </div>
                <p *ngIf="chat.createdBy" class="chat-message-detail">
                    {{chat.createdBy.name | titlecase}} - {{chat.created | date:'dd/MM/yyyy - hh:mm'}}
                </p>
                <p i18n="'You' when a message is sent by student" *ngIf="!chat.createdBy" class="chat-message-detail">
                    You - {{chat.created | date:'dd/MM/yyyy - hh:mm'}}
                </p>
            </div>
        </div> -->
    </div>
</div>